import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "subbody modulewrap"
};
const _hoisted_2 = {
  key: 0,
  class: "subbannerwrap"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "subbannertitle"
};
const _hoisted_5 = {
  key: 0,
  class: "subconcover"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "subconcoverinfo"
};
const _hoisted_8 = {
  class: "mtitle3"
};
const _hoisted_9 = {
  class: "word"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, null, -1);
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = {
  key: 1,
  class: "subconcover2"
};
const _hoisted_13 = {
  class: "subconcoverinfo2"
};
const _hoisted_14 = {
  class: "mtitle3"
};
const _hoisted_15 = {
  class: "word"
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, null, -1);
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = {
  key: 0,
  class: "subconimgs"
};
const _hoisted_19 = {
  class: "subconimgsarrowwrap"
};
const _hoisted_20 = {
  class: "arrow"
};
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-fanye"
}, null, -1);
const _hoisted_22 = [_hoisted_21];
const _hoisted_23 = {
  class: "arrow"
};
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-fanye1"
}, null, -1);
const _hoisted_25 = [_hoisted_24];
const _hoisted_26 = ["innerHTML"];
import { FFmixin } from "@/mixin/mixin.js";
export default {
  __name: 'Csubconnav',
  props: {
    navKv: {
      type: Number,
      default: 0
    },
    navKvSub: {
      type: Number,
      default: 0
    },
    root: {
      type: String,
      default: ''
    },
    hasBg: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    const FFprops = __props;
    const {
      proxy
    } = getCurrentInstance();
    const {
      setTitle
    } = FFmixin();
    const route = useRoute();
    const FFSWIPER = ref(null);
    const FFdata = reactive({
      infodata: [],
      infoDetail: {}
    });
    const getData = async () => {
      setTitle(FFprops.navKv, 0, FFprops.navKvSub, navSub => {
        let id = route.params.id;
        if (id) {
          proxy.$common.fetch({
            'act': 'telfort_navdata',
            'exts': 'id=' + id,
            msg: ''
          }, res => {
            FFdata.infoDetail = res.infodata;
          });
        } else {
          proxy.$common.fetch({
            'act': 'telfort_navthird',
            'exts': 'id=' + navSub.id,
            msg: ''
          }, res => {
            FFdata.infodata = res.infodata;
          });
        }
      });
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_fflink = _resolveComponent("fflink");
      const _component_ffswiper = _resolveComponent("ffswiper");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.$common.basic.isArrayExist(_unref(FFdata).infodata) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FFdata).infodata, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "subbannerlist zoom",
          key: item.id
        }, [_createElementVNode("img", {
          src: item.banner
        }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createVNode(_component_fflink, {
          info: item,
          root: __props.root,
          isOverDot: false
        }, null, 8, ["info", "root"])])]);
      }), 128))])) : _createCommentVNode("", true), _ctx.$common.basic.isObjExist(_unref(FFdata).infoDetail) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_unref(FFdata).infoDetail.cover ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
        class: "cover",
        src: _unref(FFdata).infoDetail.cover
      }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$common.langInfo(_unref(FFdata).infoDetail.title, _unref(FFdata).infoDetail.title_en)), 1), _hoisted_10]), _createElementVNode("div", {
        class: "subcon2 editor",
        innerHTML: _ctx.$common.langInfo(_unref(FFdata).infoDetail.content, _unref(FFdata).infoDetail.content_en)
      }, null, 8, _hoisted_11)])])) : __props.hasBg ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$common.langInfo(_unref(FFdata).infoDetail.title, _unref(FFdata).infoDetail.title_en)), 1), _hoisted_16]), _createElementVNode("div", {
        class: "subcon2 editor",
        innerHTML: _ctx.$common.langInfo(_unref(FFdata).infoDetail.content, _unref(FFdata).infoDetail.content_en)
      }, null, 8, _hoisted_17), _unref(FFdata).infoDetail.imgs ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_ffswiper, {
        ref_key: "FFSWIPER",
        ref: FFSWIPER,
        imgs: _unref(FFdata).infoDetail.imgs,
        options: {
          isstop: true,
          istrandriect: true,
          ispoint: false
        }
      }, null, 8, ["imgs"]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("a", {
        href: "#",
        onClick: _cache[0] || (_cache[0] = $event => _unref(FFSWIPER).swiperPrev())
      }, _hoisted_22)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("a", {
        href: "#",
        onClick: _cache[1] || (_cache[1] = $event => _unref(FFSWIPER).swiperNext())
      }, _hoisted_25)])])])) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "subcon editor",
        innerHTML: _ctx.$common.langInfo(_unref(FFdata).infoDetail.content, _unref(FFdata).infoDetail.content_en)
      }, null, 8, _hoisted_26))], 64)) : _createCommentVNode("", true)]);
    };
  }
};